import 'react-app-polyfill/ie9'

import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { CookiesProvider } from 'react-cookie'
import { LoginCallback } from 'views'
import PrivateRoute from 'components/PrivateRoute'

import App from 'App'

let environment = process.env.REACT_APP_NODE_ENV
if (environment === 'pull_request' || environment === 'local') {
  environment = 'staging'
}

window.PLURALL_TRACKER = new window.PlurallTracker({
  clientId: 'trails',
  environment,
  hotjarId: process.env.REACT_APP_HOTJAR_ID,
  plurallFeedback: 13,
})

const PageViewTracker = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    window.PLURALL_TRACKER.pageView()
  }, [location])

  return children
}

const root = createRoot(document.getElementById('root'))
root.render(
  <CookiesProvider>
    <BrowserRouter>
      <PageViewTracker>
        <Routes>
          <Route path='/login/callback' element={<LoginCallback />} />
          <Route
            path='/*'
            element={
              <PrivateRoute>
                <App />
              </PrivateRoute>
            }
          />
        </Routes>
      </PageViewTracker>
    </BrowserRouter>
  </CookiesProvider>,
)
